import React, { FunctionComponent, ReactNode } from 'react'
import { ExperimentProvider } from '@afterpaytouch/feature'
import { useAmplitudeWithEnduringEventProperties } from '../integrations/amplitude'
import { Experiment } from '../state/experiments/hooks'
import { triggerExperiment } from '../state/experiments/reducer'
import { useAppDispatch } from '../state/hooks'

// Define portal-specific experiments
const PortalExperiments = {
  EnabledPortalSignup: 'rocketship.enabled-portal-signup',
  // Add other portal experiments here as needed
} as const

export type PortalExperimentName = keyof typeof PortalExperiments

interface PortalExperimentProviderProps {
  children: ReactNode
}

export const PortalExperimentProvider: FunctionComponent<PortalExperimentProviderProps> = ({ children }) => {
  const { logEvent } = useAmplitudeWithEnduringEventProperties()
  const dispatch = useAppDispatch()

  // Add Redux dispatch to update the experiment state
  const reduxDispatch = (experiment: Experiment): void => {
    dispatch(triggerExperiment([experiment.name, experiment.value]))
  }

  const config = {
    monitoring: logEvent,
    experiments: PortalExperiments,
    reduxDispatch: reduxDispatch, // Add Redux dispatch to prevent double triggering
  }

  return <ExperimentProvider config={config}>{children}</ExperimentProvider>
}

export { PortalExperiments }
